import {TopNavigation} from '@frontend/modules/layout/top_navigation/TopNavigation'
import {
    useTopMenuStore,
    useUiLayoutStore,
} from '@frontend/stores'
import clsx from 'clsx'
import {ItemsSearchPanel} from '../../public/ads/components/search/ItemsSearchPanel'

// Заголовок страницы.
export function Header() {

    const topMenuStickToTop = useTopMenuStore(
        state => state.stickToTop
    )
    const topMenuWrapInCard = useTopMenuStore(
        state => state.wrapInCard
    )
    const deviceType = useUiLayoutStore(
        state => state.deviceType
    )

    const shouldWrapInCard = topMenuWrapInCard || deviceType === 'mobile'

    return (
        <header
            className={clsx(
                topMenuStickToTop ? 'stick-to-top' : '',
                shouldWrapInCard ? 'with-card' : ''
            )}
        >
            <div className="container-fluid container-xl">
                <div
                    className={clsx(
                        'header-content',
                        shouldWrapInCard ? 'card' : null
                    )}
                >
                    <TopNavigation />
                    <ItemsSearchPanel />
                </div>
            </div>
        </header>
    )
}
